import { AxiosHeaders } from "axios";
import { getLocalAccessToken } from "../services/localStorage";

export const endpoints = {
    user: 'user',
    fitting_size: 'fitting-size',
    body_size: 'body-size',
    category: 'category',
    body_shape: 'body-shape',
    connection_type: 'connection-type',
    conn_type_body_size: 'conn-type-body-size',
    measuring_unit: 'measuring-unit',
    conn_type_conn_size: 'conn-type-conn-size',
    data_version: 'data-version',
    product_type: 'product-type',
    app_update_setting: 'app-update-setting',
    nut: 'nut',
    nut_material: 'nut-material',
    nut_shape: 'nut-shape',
    orifice_size: 'orifice-size',
    orifice_config: 'orifice-config',
    body_size_config: 'body-size-config',
    conn_conversion: 'conn-conversion',
}
export const getAuthorizationHeaders = (): AxiosHeaders => {
  const accessToken = getLocalAccessToken() ? getLocalAccessToken() : '';
  return new AxiosHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer '+accessToken,
  });
};
export const getFileHeaders = (): AxiosHeaders => {
  const accessToken = getLocalAccessToken() ? getLocalAccessToken() : '';
  return new AxiosHeaders({
    'Content-Type': 'multipart/form-data',
    'Authorization': 'Bearer '+accessToken,
  });
};

